import type InviteModel from 'garaje/models/invite';
import type FeatureFlagsService from 'garaje/services/feature-flags';

/**
 * True when an invite went through a workflow and the workflow-reruns feature is on,
 * meaning editing + saving will trigger a fresh workflow re-evaluation.
 */
export function canTriggerWorkflowReeval(invite: InviteModel, featureFlags: FeatureFlagsService): boolean {
  if (!featureFlags.isEnabled('ava-invite-workflow-reruns')) return false;
  return !!invite.visitApproval?.visitWorkflowResult;
}
